import { jsxs as f, jsx as r, Fragment as S } from "react/jsx-runtime";
import { useRef as k, useCallback as I, useEffect as p } from "react";
const q = ({
  heading: c,
  subheading: s,
  children: h,
  defaultOpen: l = !1,
  icon: a,
  iconAlt: A = "Icon",
  id: d
}) => /* @__PURE__ */ f("details", { className: "Content Accordion-item", open: l || void 0, children: [
  /* @__PURE__ */ f(
    "summary",
    {
      className: "Accordion-toggle u-flexCol u-paddingVert16 u-paddingRight8",
      "aria-controls": d,
      children: [
        a && /* @__PURE__ */ r(
          "img",
          {
            className: "Accordion-icon u-marginRight8 u-sizeFull",
            src: a,
            alt: A
          }
        ),
        /* @__PURE__ */ r("span", { children: c }),
        s && /* @__PURE__ */ r("p", { className: "u-marginTop4", children: s })
      ]
    }
  ),
  /* @__PURE__ */ r("div", { className: "Accordion-content Content", id: d, "aria-expanded": "false", children: h })
] }), x = ({
  title: c,
  children: s
}) => /* @__PURE__ */ f(S, { children: [
  c && /* @__PURE__ */ r("div", { className: "Content section-title", children: /* @__PURE__ */ r("h2", { children: c }) }),
  /* @__PURE__ */ r("div", { className: "Content section-content", children: s })
] }), M = ({
  children: c,
  transparent: s,
  unruled: h,
  bgColor: l,
  className: a,
  testId: A,
  sectionTitle: d,
  sectionContent: C
}) => {
  const i = k(null), b = (t) => t === !0 || t === "true" || t === "", L = I(() => {
    const t = ["Accordion"];
    return b(s) && t.push("Accordion--transparent"), b(h) && t.push("Accordion--unruled"), t.push("u-bgColorWhite"), a && t.push(a), t.join(" ");
  }, [s, h, a]);
  return p(() => {
    if (!i.current || !l) return;
    i.current.querySelectorAll(".Accordion-content").forEach((o) => {
      switch (o.classList.remove("u-bgColorStone", "u-bgColorMintLight10"), l) {
        case "stone":
        case "gray":
          o.classList.add("u-bgColorStone");
          break;
        case "mint light":
          o.classList.add("u-bgColorMintLight10");
          break;
      }
    });
  }, [l, c]), p(() => {
    if (!i.current) return;
    const t = i.current, o = (e) => {
      e.preventDefault();
      const v = e.target.hash;
      if (v) {
        const y = t.querySelector(
          `a[name="${v.replace("#", "")}"]`
        );
        if (y) {
          const g = y.closest(
            "details.Content.Accordion-item"
          );
          g && (g.setAttribute("open", ""), g.scrollIntoView({ behavior: "smooth" }));
        }
      }
    }, m = t.querySelectorAll(".Accordion-content a[href]"), u = Array.from(m).filter(
      (e) => {
        var n;
        return (n = e.hash) == null ? void 0 : n.includes("#inner");
      }
    );
    return u.forEach((e) => {
      e.addEventListener("click", o);
    }), () => {
      u.forEach((e) => {
        e.removeEventListener("click", o);
      });
    };
  }, [c]), p(() => {
    var u;
    if (!i.current) return;
    const t = i.current, o = (u = globalThis.location) == null ? void 0 : u.hash;
    if (o) {
      const e = t.querySelector(
        `a[name="${o.replace("#", "")}"]`
      );
      if (e) {
        const n = e.closest(
          "details.Content.Accordion-item"
        );
        n && (n.setAttribute("open", ""), n.scrollIntoView({ behavior: "smooth" }));
        return;
      }
    }
    const m = t.querySelector(
      '.Accordion-content a[name="default"]'
    );
    if (m) {
      const e = m.closest(
        "details.Content.Accordion-item"
      );
      e && e.setAttribute("open", "");
    } else {
      const e = t.querySelector(
        "details.Accordion-item"
      ), n = t.querySelector(".Accordion-content");
      e && n && (e.removeAttribute("open"), n.setAttribute("aria-expanded", "false"));
    }
  }, []), /* @__PURE__ */ f("div", { ref: i, className: L(), "data-testid": A || null, children: [
    d && /* @__PURE__ */ r(
      "div",
      {
        className: "Content section-title",
        dangerouslySetInnerHTML: { __html: `<h2>${d}</h2>` }
      }
    ),
    C && /* @__PURE__ */ r(
      "div",
      {
        className: "Content section-content",
        dangerouslySetInnerHTML: { __html: C }
      }
    ),
    c
  ] });
};
export {
  M as Accordion,
  q as AccordionItem,
  x as AccordionSection
};
//# sourceMappingURL=Accordion.mjs.map
